export class InteriorDeficiencyLayout {
	public fields = [
		{ fieldName: 'deficiencyName', label: 'Name' },
		{ fieldName: 'deficiencyType', label: 'Type' },
		{ fieldName: 'interiorDeficiencySeverity', label: 'Severity' },
		{ fieldName: 'descriptionInteriorDeficiency', label: 'Description' },
		{ fieldName: 'deficiencyRemediationType', label: 'Remediation Type' }
	];
}
